import gql from 'graphql-tag'
import {userFragment} from '../fragments'


export const CreateComment = gql`
mutation CreateComment($text: String, $lectureId: ID!, $studentId: ID!) {
  createComment(text: $text, lectureId: $lectureId, studentId: $studentId) {
    comment {
      id
      text
      lecture {
        id
      }
      student {
        id
      }
      createdAt
      score
      isScored
      isSent
    }
  }
}
`


export const UpdateComment = gql`
mutation UpdateComment($id: ID!, $place: String, $userId: ID) {
  updateComment(id: $id,place: $place, userId: $userId) {
    manager {
      id
      place
      user {
        ...userFragment
      }
    }
  }
}
${userFragment}
`


export const DeleteComment = gql`
mutation DeleteComment($id: ID!) {
  deleteComment(id: $id) {
    id_
  }
}
`
